import React, { useEffect } from 'react';
import numeral from 'numeral';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminPage from '../hocs/AdminPage';
import AdminEventHeader from '../AdminEventHeader';
import TenantLink from '../TenantLink';

const db = firebase.firestore();

const typeLabels = {
  eventFollower: 'フォロワー',
  eventEntry: '参加者',
  cancellationNotice: 'キャンセル待ち'
};

export default AdminPage(function AdminEventEmailHistories(props) {
  const {
    user,
    match: {
      params: { eventId },
    },
    addBreadNavValues,
  } = props;

  const event = useDocumentSubscription(db.collection('events').doc(eventId), [eventId]);
  const emailHistories = useCollectionSubscription(
    event?.ref.collection('emailHistories').orderBy('createdAt', 'desc'),
    [event]
  );

  useEffect(() => {
    addBreadNavValues({ event });
  }, [event]);

  return (
    event != null && (
      <div>
        <div className="admin-event-email-histories container-fluid py-5 position-relative">
          <AdminEventHeader activeTab="emailHistories" event={event} user={user} />
          <div className="bg-white p-4">
            <div className="row">
              <div className="col-12">
                <h5 className="text-center">メール送信履歴</h5>
                <div className="mb-3">
                  {numeral(emailHistories.length).format()}件
                </div>
                {emailHistories.length > 0 ? (
                  <table className="table">
                    <thead className="thead-light text-center">
                      <tr>
                        <th style={{ minWidth: 150 }}>送信日時</th>
                        <th style={{ minWidth: 100 }}>送信先</th>
                        <th style={{ minWidth: 200 }}>件名</th>
                        <th style={{ minWidth: 100 }}>送信件数</th>
                        <th style={{ minWidth: 150 }}>送信者</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emailHistories.map((history) => {
                        const { id, type, subject, sentCount, createdBy, createdAt } = history;
                        return (
                          <tr key={id}>
                            <td>
                              <TenantLink to={`/admin/events/${eventId}/emailHistories/${id}`}>
                                {createdAt.toDate().toLocaleString()}
                              </TenantLink>
                            </td>
                            <td>{typeLabels[type] || type}</td>
                            <td>{subject}</td>
                            <td>{numeral(sentCount).format()}件</td>
                            <td>{createdBy.displayName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div>メール送信履歴はありません</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
});
